import {FC} from "react";
import {Colors} from "@brg/ui";
import styled from "styled-components";
import {RectangularButtonFilled} from "../buttons";
import {useGetNearLesson} from "../../hooks/api/LMS/useGetNearLesson";
import { LayoutConst } from "core";
import { NearLessonStatus } from "shared/pages/myCourses/Schedule/components/NearLessonStatus";
import { ICourseModuleCard } from "shared/constants/courses/ICourseModuleCard";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  row-gap: 24px;
  margin-top: 32px;
`

const NearLessonBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
  // background: ${Colors.galBlack5};
  background-color: transparent;
  border-radius: 8px;
  @media (max-width: ${LayoutConst.screen.l_12}px){
    max-width: 920px;
  }
  @media (max-width: ${LayoutConst.screen.md}px){
    max-width: 712px;
    padding: 0;
  }
  @media (max-width: ${LayoutConst.screen.s - 1}px){
    padding: 0;
  }
`

const LessonButton = styled(RectangularButtonFilled)`
  padding: 12px 48px;
  height: 46px !important;
  font-weight: 600;
   @media (max-width: ${LayoutConst.screen.s - 1}px){
    width: 100%;
    padding: 8px 24px;
    height: 36px !important;
  }
`
const ChatButton = styled(LessonButton)`
  width: 270px;
`

export const NearLessonBlock: FC<{
  teamId?: string,
  hideCourse?: boolean, 
  isTeacher?: boolean,
  module?: ICourseModuleCard<'Local'>
}> = ({
  teamId, 
  module, 
  isTeacher
}) => {

    const {lesson: lesson} = useGetNearLesson(teamId)

    if (!lesson?.chatLink && !lesson?.lessonInfo?.start && !module) return null;

    return <Wrapper>
        {lesson?.chatLink && <ChatButton onClick={() => window.open(lesson?.chatLink, '_blank')}>Чат группы</ChatButton>}
        {lesson?.lessonInfo?.start && <NearLessonBlockWrapper>
        <NearLessonStatus {...(module ? {module} : {})} fullWidth isTeacher={isTeacher}/>
    </NearLessonBlockWrapper>}
    </Wrapper>
}import {FC} from "react";
import {Colors} from "@brg/ui";
import styled from "styled-components";
import {RectangularButtonFilled} from "../buttons";
import {useGetNearLesson} from "../../hooks/api/LMS/useGetNearLesson";
import { LayoutConst } from "core";
import { NearLessonStatus } from "shared/pages/myCourses/Schedule/components/NearLessonStatus";
import { ICourseModuleCard } from "shared/constants/courses/ICourseModuleCard";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  row-gap: 24px;
  margin-top: 32px;
`

const NearLessonBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
  // background: ${Colors.galBlack5};
  background-color: transparent;
  border-radius: 8px;
  @media (max-width: ${LayoutConst.screen.l_12}px){
    max-width: 920px;
  }
  @media (max-width: ${LayoutConst.screen.md}px){
    max-width: 712px;
    padding: 0;
  }
  @media (max-width: ${LayoutConst.screen.s - 1}px){
    padding: 0;
  }
`

const LessonButton = styled(RectangularButtonFilled)`
  padding: 12px 48px;
  height: 46px !important;
  font-weight: 600;
   @media (max-width: ${LayoutConst.screen.s - 1}px){
    width: 100%;
    padding: 8px 24px;
    height: 36px !important;
  }
`
const ChatButton = styled(LessonButton)`
  width: 270px;
`

export const NearLessonBlock: FC<{
  teamId?: string,
  hideCourse?: boolean, 
  isTeacher?: boolean,
  module?: ICourseModuleCard<'Local'>
}> = ({
  teamId, 
  module, 
  isTeacher
}) => {

    const {lesson: lesson} = useGetNearLesson(teamId)

    if (!lesson?.chatLink && !lesson?.lessonInfo?.start && !module) return null;

    return <Wrapper>
        {lesson?.chatLink && <ChatButton onClick={() => window.open(lesson?.chatLink, '_blank')}>Чат группы</ChatButton>}
        {lesson?.lessonInfo?.start && <NearLessonBlockWrapper>
        <NearLessonStatus {...(module ? {module} : {})} fullWidth isTeacher={isTeacher}/>
    </NearLessonBlockWrapper>}
    </Wrapper>
}